/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} ShortformInputs */

const en_shortform = /** @type {(inputs: ShortformInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Shortform`)
};

const fr_shortform = /** @type {(inputs: ShortformInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Abréviation`)
};

const de_shortform = /** @type {(inputs: ShortformInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kurzform`)
};

const it_shortform = /** @type {(inputs: ShortformInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Versione abbreviata`)
};

const ru_shortform = /** @type {(inputs: ShortformInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Краткая форма`)
};

const es_shortform = /** @type {(inputs: ShortformInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Formato corto`)
};

const zh_cn2_shortform = /** @type {(inputs: ShortformInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`简体`)
};

const ja_shortform = /** @type {(inputs: ShortformInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ショートフォーム`)
};

const hi_shortform = /** @type {(inputs: ShortformInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`संक्षिप्त रूप`)
};

const pt_pt2_shortform = /** @type {(inputs: ShortformInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Forma abreviada`)
};

/**
* | output |
* | --- |
* | "Shortform" |
*
* @param {ShortformInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const shortform = /** @type {((inputs?: ShortformInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<ShortformInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_shortform(inputs)
	if (locale === "de") return de_shortform(inputs)
	if (locale === "it") return it_shortform(inputs)
	if (locale === "ru") return ru_shortform(inputs)
	if (locale === "es") return es_shortform(inputs)
	if (locale === "zh-CN") return zh_cn2_shortform(inputs)
	if (locale === "ja") return ja_shortform(inputs)
	if (locale === "hi") return hi_shortform(inputs)
	if (locale === "pt-PT") return pt_pt2_shortform(inputs)
	return en_shortform(inputs)
});